<template>
  <div>
    <div class="row">
      <div class="col-12">
        <form class="kt-form">
          <div class="kt-form__group form-group row">
            <label class="col-3 col-md-1 col-form-label font-weight-bold">Enable</label>
            <div class="col-3 col-md-1">
              <span class="kt-switch kt-switch--outline kt-switch--icon kt-switch--success">
                <label>
                  <input type="checkbox" :checked="user.two_factor_enabled"
                         name=""
                         @change="toggle2fa">
                  <span />
                </label>
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Created At</th>
              <th>Expires At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="authenticated_devices.length">
            <tr v-for="(device, index) in authenticated_devices" :key="index" valign="middle">
              <td>{{ device.name }}</td>
              <td>{{ toLocalTime(device.created_at) }}</td>
              <td>{{ toLocalTime(device.expires_at) }}</td>
              <td>
                <a href="javascript:void(0)" class="btn btn-ss btn-sm" @click="removeDevice(device.id, index)">
                  <i class="fa fa-trash" /> Remove
                </a>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">
                <strong>You have no authenticated devices.</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mysqlDateTimeUTCToLocal } from "Helpers/formatters";

export default {
  props: {
    userToEdit: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    user: {},
    authenticated_devices: [],
  }),
  mounted() {
    if (this.userToEdit?.uuid) {
      this.user = this.userToEdit;
    } else {
      this.user = window.user;
    }

    const data = {
      params: {
        user_uuid: this.user.uuid,
      },
    };

    axios.get(`/api/v1/2fa/devices`, data).then((response) => {
      if (response.data && response.data.data) {
        this.authenticated_devices = response.data.data;
      }
    }).catch((error) => {
      window.handleAxiosError(error);
    });
  },
  methods: {
    toLocalTime(value) {
      return mysqlDateTimeUTCToLocal(value, 'DD/MM/YYYY HH:mm:ss');
    },
    toggle2fa() {
      const new_value = !this.user.two_factor_enabled;
      this.user.two_factor_enabled = new_value;
      if (new_value) {
        this.enableTwoFactorAuthentication();
      } else {
        this.disableTwoFactorAuthentication();
      }
    },
    enableTwoFactorAuthentication() {
      const data = {
        params: {
          user_id: this.user.uuid,
        },
      };
      axios.get('/api/v1/2fa/enable', data).then((response) => {
        if (response.data.data && response.data.data.secret && response.data.data.image) {
          this.secret = response.data.data.secret;
          this.image = response.data.data.image;
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    disableTwoFactorAuthentication() {
      const data = {
        params: {
          user_id: this.user.uuid,
        },
      };

      axios.get('/api/v1/2fa/disable', data).then((response) => {
        if (response.data.data) {
          toastr.success("Disabled Two Factor Authentication");
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    removeDevice(device_id, index) {
      const data = {
        params: {
          user_id: this.user.uuid,
        },
      };
      axios.delete(`/api/v1/2fa/device/${device_id}`, data).then(() => {
        toastr.success("Removed Device");
        Vue.delete(this.authenticated_devices, index);
      }).catch((error) => {
        if (error.status === 401) {
          toastr.error("You don't have permission to delete this device");
        } else {
          console.error(error);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
    @media(min-width:992px){
        .vertical-align {
            display: flex;
            align-items: center;
        }
    }
    .table > tbody > tr > td {
        vertical-align: middle;
    }

    .download-buttons {
        margin-bottom:1em;
        .btn {
            margin-right:1em;
        }
    }
</style>
